// extracted by mini-css-extract-plugin
export default {"container":"DM-z","topReviewHeading":"EM-z","criticalReview":"FM-z","favorableReview":"GM-z","vsSeparator":"HM-z"};